export const GET_NETWORK_ERROR_CODE = 'GET_NETWORK_ERROR_CODE';
